import { QueryClient } from '@tanstack/react-query'
import { ApiError } from './api'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 30_000,
      // Zonder dit pauzeert een query zodra de browser denkt dat er geen
      // verbinding is: hij blijft dan in de laadstaat hangen zonder ooit een
      // fout te melden, en je kijkt naar een skelet dat nooit iets wordt. Liever
      // gewoon proberen en de mislukking laten zien; dit is een app die je
      // online gebruikt, dus een verzoek dat niet aankomt is een fout.
      networkMode: 'always',
      retry: (failureCount, error) => {
        if (error instanceof ApiError && error.status >= 400 && error.status < 500) return false
        return failureCount < 2
      },
    },
  },
})
